<template>
  <div class="d-flex mt-3 mx-5">
    <AnalysisElementVotes
      class="ml-4 mt-2"
      v-if="userAnalysis"
      :item="element.element"
      :analysis-id="currentAnalysis.id"
      :user-analysis-id="userAnalysis.id"
      :user-id="userDetails.userId"
    />
    <div class="ml-4">
      <div class="elementText mt-2 mb-2">
        {{ element.element.text }}
      </div>
      <TopElementUserBar :element="element" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import AnalysisElementVotes from './votes/AnalysisElementVotes';
import TopElementUserBar from './TopElementUserBar';
import { types as userTypes } from '../../store/user';
import { types as analysesTypes } from '../../store/analyses';

export default {
  name: 'TopElement',
  components: {
    TopElementUserBar,
    AnalysisElementVotes,
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      userDetails: userTypes.getters.userDetails,
      currentAnalysisUserAnalyses: analysesTypes.getters.currentAnalysisUserAnalyses,
      currentAnalysis: analysesTypes.getters.currentAnalysis,
    }),
    userAnalysis() {
      return this.currentAnalysisUserAnalyses.find(userAnalysis => userAnalysis.id === this.element.userId);
    },
  },
};
</script>
<style scoped>
.elementText {
  font-size: 13px;
}
</style>
